import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BellSimple, Check } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import api from "@/lib/api";

export default function NotificationBell() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/notifications").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  const unread = items.filter((i) => !i.read).length;

  const markAll = async () => {
    await api.post("/notifications/mark-all-read");
    load();
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" data-testid="notification-bell-btn" aria-label="Notifications" className="relative">
          <BellSimple size={18} weight={unread > 0 ? "fill" : "regular"} />
          {unread > 0 && (
            <span className="absolute -top-0.5 -end-0.5 w-4 h-4 rounded-full bg-[var(--danger)] text-white text-[10px] font-semibold flex items-center justify-center">
              {unread > 9 ? "9+" : unread}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0 glass-strong border-0 overflow-hidden max-h-[70vh]">
        <div className="p-3 border-b border-[var(--border)] flex items-center justify-between">
          <div className="overline">Notifications</div>
          {unread > 0 && <button onClick={markAll} data-testid="mark-all-read-btn" className="text-xs text-[var(--accent)] hover:underline">Mark all read</button>}
        </div>
        <div className="max-h-96 overflow-y-auto">
          {items.length === 0 && <div className="p-6 text-center text-sm text-[var(--text-3)]">No notifications</div>}
          {items.map((n) => (
            <Link
              key={n.id}
              to={n.link || "#"}
              data-testid={`notif-${n.id}`}
              className={`block p-3 border-b border-[var(--border)] hover:bg-[var(--surface-2)] transition ${n.read ? "opacity-60" : ""}`}
            >
              <div className="flex items-start gap-2">
                {!n.read && <span className="w-1.5 h-1.5 mt-2 rounded-full bg-[var(--accent)] shrink-0" />}
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium truncate">{n.title}</div>
                  <div className="text-xs text-[var(--text-3)] mt-0.5">{n.description}</div>
                  <div className="text-[10px] text-[var(--text-3)] mt-1 font-mono">{new Date(n.created_at).toLocaleString()}</div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
